// Pinned nav destinations: what survives a round trip, and what does not.
//
// Modelled on workflow/filterPrefs.js, including its central rule -- unknown
// values are DISCARDED rather than applied. The server stores pin ids
// opaquely (it deliberately holds no copy of the nav's item list), so a pin
// saved by an older build can outlive the item it names. Rendering it would
// put a dead link at the top of the nav.

// Matches MAX_PINS in backend/core/nav_views.py. The server rejects a ninth;
// this stops the UI offering one in the first place.
export const MAX_PINS = 8;

export function sanitizePins(raw, knownIds) {
  if (!Array.isArray(raw)) return [];
  const known = new Set(knownIds || []);
  const seen = new Set();
  const out = [];
  for (const id of raw) {
    if (typeof id !== "string") continue;
    if (!known.has(id)) continue;
    if (seen.has(id)) continue;
    seen.add(id);
    out.push(id);
    if (out.length === MAX_PINS) break;
  }
  return out;
}

export function togglePin(pins, id) {
  const current = Array.isArray(pins) ? pins : [];
  if (current.includes(id)) return current.filter((p) => p !== id);
  // At the cap, return the list unchanged so the caller can say why rather
  // than the click appearing to do nothing.
  if (current.length >= MAX_PINS) return current;
  return [...current, id];
}
